'use strict';

var React = require('react');

var SvgLiveViewFilledMajor = function SvgLiveViewFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.523 6.28a5.25 5.25 0 0 0 0 7.425.75.75 0 1 1-1.06 1.06 6.75 6.75 0 0 1 0-9.545.75.75 0 0 1 1.06 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.462 13.705a5.25 5.25 0 0 0 0-7.425.75.75 0 1 1 1.061-1.06 6.75 6.75 0 0 1 0 9.546.75.75 0 0 1-1.06-1.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79 8.048a2.75 2.75 0 0 0 0 3.89.75.75 0 1 1-1.06 1.06 4.25 4.25 0 0 1 0-6.01.75.75 0 1 1 1.06 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.194 11.937a2.75 2.75 0 0 0 0-3.889.75.75 0 1 1 1.061-1.06 4.25 4.25 0 0 1 0 6.01.75.75 0 0 1-1.06-1.06Z"
  }));
};
SvgLiveViewFilledMajor.displayName = "LiveViewFilledMajor";

exports.SvgLiveViewFilledMajor = SvgLiveViewFilledMajor;
